import type {TJoySnackbarLevels} from '@maltjoy/core-vue';
import {pushVJoySnackbar} from '@maltjoy/core-vue';

export function createSnackNotifier() {
    function push(level: TJoySnackbarLevels, message: string) {
        if (import.meta.client) {
            // pushVJoySnackbar has no meaning executed server-side (and it doesn't work server-side)
            pushVJoySnackbar({
                props: {
                    level,
                    message,
                },
            });
        }
    }

    return {
        push,
    };
}
